import Distance from "../../components/Distance";
import Duration from "../../components/duration/Duration";
import { BookingType } from "BookingType";
import React from "react";

type Ride = {
  booking_type: BookingType;
  distance: number;
  duration?: number;
};

type DistanceOrDurationProps = {
  ride: Ride;
};

export function DistanceOrDuration({ ride }: DistanceOrDurationProps) {
  if (ride.booking_type === "transfer" && ride.distance) {
    return <Distance valueInMetres={ride.distance} />;
  } else if (ride.booking_type === "hourly" && ride.duration) {
    return <Duration valueInSeconds={ride.duration} format="short" />;
  }
  return null;
}
